//import "./style.css";
import symbols from "./anneca-symbols.json";

export class StyledIcon {

	constructor(name, entity, clazz, style) {
		this.name = name;
		this.entity = entity;
		this.clazz = clazz;
		this.style = style;
		this.attrs = new Map();
		this.id = null;
	}

	appendClass(cls) {
		if (!cls) return this;
		if (!this.clazz) this.clazz = cls;
		else this.clazz = this.clazz + " " + cls;
		return this;
	}

	appendStyle(css) {
		if (!css) return this;
		if (!this.style) this.style = css;
		else this.style = this.style + ";" + css;
		return this;
	}

	withId(id) {
		this.id = id;
		return this;
	}

	attr(name, value) {
		this.attrs.set(name, value);
		return this;
	}
}


export class Icon {
	/**
	 * Generate icon element
	 * @param {string} iconName
	 * @param {?string} cls extra style
	 * @param {?string} css extra css class
	 * @param {?string} id attribute
	 */
	static fi(iconName, cls = null, css = null, id = null) {
		const i = Icon.parse(iconName);
		i.appendClass(cls).appendStyle(css).withId(id);
		return Icon.generate(i);
	}

	/**
	 * @param {StyledIcon} i
	 * @return {string}
	 */
	static generate(i) {
		let b = '<span class="fi';
		if (i.clazz) b = b + ' ' + i.clazz;
		b = b + '"';
		if (i.style) b = b + ' style="' + i.style + '"';
		if (i.id) b = b + ' id="' + i.id + '"';
		if (i.attrs.size > 0) {
			for (let a of i.attrs.entries()) {
				b = b + ' ' + a.key + '="' + a.value + '"';
			}
		}
		b = b + '>' + i.entity + '</span>';
		return b;
	}


	/**
	 * Recognize format: <icon-name>(.class1(.class2)...){<css-styles>}
	 * Example: email.dimmed{margin-right:30px}   .... icon named "email" with class "dimmed" and CSS style "margin-right:30px"
	 * @param {string} extendedIconName
	 * @return {StyledIcon}
	 */
	static parse(extendedIconName) {
		const si = new StyledIcon();

		const styleStart = extendedIconName.indexOf('{');
		if (styleStart > 0) {
			const styleEnd = extendedIconName.indexOf('}', styleStart);
			if (styleEnd > 0) {
				// Has style info
				si.style = extendedIconName.substring(styleStart+1, styleEnd).trim();
				extendedIconName = extendedIconName.substring(0, styleStart).trim();
			}
		}
		const parts = extendedIconName.split(/\./);
		si.name = parts[0];
		if (parts.length > 1) {
			parts.shift();
			si.clazz = parts.join(" ");
		}
		si.entity = Icon.entity(si.name);
		return si;
	}

	static entity(iconName) {
		const e = symbols[iconName];
		if (e) return e;
		return PLACEHOLDER.entity;
	}

	static symbols() {
		return symbols;
	}
}

const PLACEHOLDER = new StyledIcon("placeholder", "&#xEE00;");

if (typeof window.Icon === "undefined") {
	window.Icon = {
		...symbols,

		entity: Icon.entity,
		fi: Icon.fi
	}
}
